import React, { useMemo } from "react";
import { Col, Row } from "antd";
import SectionCard from "./SectionCard";
import { groupSection } from "./utils";
import "../../IpEMR/summary.css";
import "../../IpEMR/InspectionSummaries/summary-wrapper.css";

const DynamicFormSummary = ({ sections = [], values = {} }) => {
  const sectionViews = useMemo(
    () =>
      (sections || [])
        .map((section) => ({
          id: section.id,
          title: section.title,
          groups: groupSection(section),
        }))
        .filter((section) => section.groups.length > 0),
    [sections]
  );

  if (sectionViews.length === 0) return null;

  return (
    <Row className="summaries" gutter={[16, 16]}>
      {sectionViews.map((section) => (
        <Col key={section.id} xs={24} md={12}>
          <SectionCard section={section} values={values} />
        </Col>
      ))}
    </Row>
  );
};

export default DynamicFormSummary;
